<template lang="pug">
transition(name="fade", mode="out-in", appear)
  .text-center(v-if="loading && usercase", key="loading")
    v-progress-circular(size="64", indeterminate)

  div(v-else, key="content")
    .mb-4.pa-6.rounded
      template(v-if="usercase.status === 'review_in_progress'")
        v-card.mb-2
          v-card-text
            .subtitle-2.mb-2
              | Is this application
              | ready for submission
              | on the Home Office website?
            .d-flex.justify-space-around.pa-4
              v-menu(
                v-model="rejectMenu",
                offset-x,
                :nudge-width="400",
                :close-on-content-click="false"
              )
                template(v-slot:activator="{ on, attrs }")
                  v-btn(color="error", v-bind="attrs", v-on="on") reject
                v-card
                  v-card-title Add comment
                  v-card-text
                    v-textarea(v-model="rejectComment", label="Reject message")
                  v-card-actions
                    v-spacer
                    v-btn(text="", @click="rejectMenu = false")
                      | Cancel
                    v-btn(color="primary", text="", @click="rejectOA")
                      | Reject
              v-btn.ml-2(color="success", @click="approveOA") approve

      template(v-if="usercase.status === 'transfer_data_to_UKVI'")
        v-card.mb-2
          v-card-title Log in details
          v-card-text
            v-row.mb-2(align="center")
              v-col(cols="2") Website
              v-col
                v-text-field(
                  v-model="website",
                  label="Website",
                  hide-details,
                  :disabled="usercase.ukvi_link !== ''"
                )

            v-row.mb-2(align="center")
              v-col(cols="2") User ID
              v-col
                v-text-field(
                  v-model="uid",
                  label="User ID",
                  hide-details,
                  :disabled="usercase.ukvi_login !== ''"
                )

            v-row.mb-2(align="center")
              v-col(cols="2") Password
              v-col
                v-text-field(
                  v-model="password",
                  label="Password",
                  hide-details,
                  :disabled="usercase.ukvi_password !== ''"
                )

            .d-flex.mb-2.justify-center
              v-btn(
                v-if="(usercase.ukvi_link !== '') & (usercase.ukvi_login !== '') & (usercase.ukvi_password !== '')",
                color="primary",
                @click="notifyUser"
              ) notify
              v-btn(v-else, color="primary", @click="saveCredits") save

    .mb-4.d-flex.justify-end
      v-btn(v-if="allOpened", width="150", @click="opened = []") collapse all
      v-btn(v-else, width="150", @click="opened = tabIndexes") expand all

    v-expansion-panels(hover, multiple, v-model="opened")
      v-expansion-panel(v-for="(tab, i) in tabs", :key="i")
        v-expansion-panel-header
          .title {{ i + 1 }}. {{ tab.title }}
        v-expansion-panel-content
          .pt-4
            .pa-4.rounded.teal.accent-2(v-if="tab.title === 'Documents'")
              .mb-2
                | Here is the list of documents
                | you've uploaded for expert review.
              DocumentTable(:items="tab.items")

            template(v-else-if="tab.subs")
              .pa-4.rounded.teal.accent-2(
                v-for="(sub, j) in tab.subs",
                :key="j",
                :class="{ 'mt-4': j }"
              )
                .mb-4.subtitle-1.font-weight-bold(
                  v-if="sub.title",
                  v-text="sub.title"
                )
                v-row.mb-2(
                  v-for="(item, k) in sub.items",
                  :key="k",
                  no-gutters
                )
                  v-col(cols="5") {{ item.label }}
                  v-col
                    div(v-for="val in item.value") {{ val }}

            .pa-4.rounded.teal.accent-2(v-else)
              v-row.mb-2(v-for="(item, j) in tab.items", :key="j", no-gutters)
                v-col(cols="5") {{ item.label }}
                v-col
                  div(v-for="val in item.value") {{ val }}
</template>

<script>
import DocumentTable from "@/components/Cases/Sponsorship/views/OnlineApplication/components/DocumentTable";
import addressesUKVI from "@/components/Cases/Sponsorship/views/OnlineApplication/data/UKVI_addresses";
import detailsLogin from "@/components/Cases/Sponsorship/views/OnlineApplication/data/login_details";
import letter from "@/components/Cases/Sponsorship/views/OnlineApplication/data/letter";
import { expertAPI } from "@/utils/apiUrls";
import { prettifyValue } from "@/utils/prettifyValue";

export default {
  name: "expert-case-online_application",

  components: {
    DocumentTable,
  },

  data() {
    return {
      reqCount: 0,
      data: [],
      opened: [],
      website: this.usercase?.ukvi_link,
      uid: this.usercase?.ukvi_login,
      password: this.usercase?.ukvi_password,
      statuses: [
        "started_company_profile",
        "started_case_profile",
        "accepting_terms",
        "payment",
        "paid",
        "ready_for_review",
        "in_progress",
        "ready_for_submission",
        "profile_change_required",
        "submitted_to_UKVI",
      ],
      modal: false,
      date: null,
      detailsLogin,
      addressesUKVI,
      letter,
      rejectMenu: false,
      rejectComment: "",
      application: [],
      loading: false,
    };
  },

  computed: {
    usercase() {
      return this.$store.state.expert.usercase.usercase;
    },

    selectedCase() {
      return this.usercase;
    },

    status() {
      return this.selectedCase?.status || null;
    },

    statusIndex() {
      return this.statuses.indexOf(this.usercase.status);
    },

    tabs() {
      if (this.application) {
        return [
          ...this.application.map((category) => ({
            title: category.title,
            subs: category.subs.map((sub) => ({
              title: sub.title,
              items: sub.items.map((item) => ({
                label: item.label,
                value: item?.value.map((val) => prettifyValue(val)),
              })),
            })),
          })),
          {
            title: "Documents",
            items: this.selectedCase?.documents || [],
          },
        ];
      } else {
        return [];
      }
    },

    allOpened() {
      return this.opened.length === this.tabs.length;
    },

    tabIndexes() {
      return this.tabs.map((_el, i) => i);
    },

    dateValid() {
      return !!this.date;
    },
  },

  methods: {
    notifyUser() {
      this.loading = true;
      this.axios
        .get(expertAPI.usercase.sponsorship.NotyfyOAURL(this.usercase.ID))
        .then(() => {
          this.$store.dispatch("expert/usercase/refreshUsercase");
          this.loading = false;
        });
    },

    saveCredits() {
      this.loading = true;
      this.axios
        .post(
          expertAPI.usercase.sponsorship.UpdateCaseCreditsURL(this.usercase.ID),
          {
            ukvi_link: this.website,
            ukvi_login: this.uid,
            ukvi_password: this.password,
          }
        )
        .then(() => {
          this.$store.dispatch("expert/usercase/refreshUsercase");
          this.loading = false;
        });
    },

    approveOA() {
      this.loading = true;
      this.axios
        .get(
          expertAPI.usercase.sponsorship.decision.ApproveCaseURL(
            this.usercase.ID
          )
        )
        .then(() => {
          this.$store.dispatch("expert/usercase/refreshUsercase");
          this.loading = false;
        });
    },

    rejectOA() {
      this.loading = true;
      this.axios
        .post(
          expertAPI.usercase.sponsorship.decision.RejectCaseURL(
            this.usercase.ID
          ),
          {
            message: this.rejectComment,
          }
        )
        .then(() => {
          this.rejectMenu = false;
          this.rejectComment = "";
          this.$store.dispatch("expert/usercase/refreshUsercase");
          this.loading = false;
        });
    },

    prettifyValue(value) {
      return prettifyValue(value);
    },

    async getApplication(caseId) {
      this.loading = true;
      await this.axios
        .get(expertAPI.usercase.sponsorship.GetCaseOnlineApplicationURL(caseId))
        .then((r) => {
          this.loading = false;
          this.application = r.data;
        })
        .catch(console.error);
    },
  },

  async mounted() {
    await this.getApplication(this.usercase.ID);
  },
};
</script>
